// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/mobile'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import VueAreaLinkage from 'vue-area-linkage'
import 'vue-area-linkage/dist/index.css'
import store from './store/index'
import 'video.js/dist/video-js.min.css'
import './errorLog'
Vue.use(MintUI)
Vue.use(VueAreaLinkage)

import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx
import { Popup } from 'vant';
import { NoticeBar } from 'vant';
import { Search } from 'vant';
import { Tab } from 'vant';
import { Tabs } from 'vant';
import { Field } from 'vant';
import { Button } from 'vant';
import { Loading } from 'vant';
import { Overlay } from 'vant';
import 'vant/lib/index.css'
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Search);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Button);
Vue.use(Loading);
Vue.use(Overlay);
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js